import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7b8d2380")

_pushScopeId("data-v-7b8d2380")
const _hoisted_1 = { class: "ui__defectList_main" }
const _hoisted_2 = { class: "ui__defectList_title_left" }
const _hoisted_3 = { class: "ui__defectList_title_right" }
const _hoisted_4 = {
  key: 0,
  class: "ui__defectList_title_defect"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "abnormal" }
const _hoisted_7 = {
  key: 0,
  class: "test-abnormal"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "abnormal" }
const _hoisted_11 = {
  key: 0,
  class: "test-abnormal"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "abnormal" }
const _hoisted_15 = {
  key: 1,
  class: "ui__defectList_title_all"
}
const _hoisted_16 = { class: "ui__defectList_title_icon" }
const _hoisted_17 = {
  key: 0,
  class: "title_line"
}
const _hoisted_18 = { class: "ui__defectList_list" }
const _hoisted_19 = { class: "ui__defectList_list_item_flex" }
const _hoisted_20 = { class: "ui__defectList_list_item_left" }
const _hoisted_21 = { class: "ui__defectList_list_item_right" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "ui__defectList_item_title" }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "ui__defectList_item_title" }
const _hoisted_26 = {
  key: 0,
  class: "ui__defectList_list_item_bottom"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_bannerModel = _resolveComponent("bannerModel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ui__defectList_title",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIsShowAllState()))
    }, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.state.listName), 1),
      _createVNode("div", _hoisted_3, [
        (_ctx.state.listDefectNumber > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              (_ctx.state.listName=='事故检测')
                ? (_openBlock(), _createBlock("span", _hoisted_5, [
                    _createVNode("span", _hoisted_6, [
                      _createVNode("img", {
                        class: "ui__defectList_title_defect_icon",
                        src: require('@/assets/image/warning.png')
                      }, null, 8, ["src"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.listDefectNumber) + "项异常 ", 1)
                    ]),
                    (_ctx.state.importantNumber > 0)
                      ? (_openBlock(), _createBlock("span", _hoisted_7, [
                          _hoisted_8,
                          _createVNode("img", {
                            class: "ui__defectList_title_defect_icon",
                            src: require('@/assets/image/warning.png')
                          }, null, 8, ["src"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.state.importantNumber) + "项重大" + _toDisplayString(_ctx.state.listName.substring(0,2)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.state.listName=='火烧检测' || _ctx.state.listName=='泡水检测')
                  ? (_openBlock(), _createBlock("span", _hoisted_9, [
                      _createVNode("span", _hoisted_10, [
                        _createVNode("img", {
                          class: "ui__defectList_title_defect_icon",
                          src: require('@/assets/image/warning.png')
                        }, null, 8, ["src"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.state.listDefectNumber) + "项异常 ", 1)
                      ]),
                      (_ctx.state.importantNumber > 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_11, [
                            _hoisted_12,
                            _createVNode("img", {
                              class: "ui__defectList_title_defect_icon",
                              src: require('@/assets/image/warning.png')
                            }, null, 8, ["src"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.state.importantNumber) + "项" + _toDisplayString(_ctx.state.listName.substring(0,2)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_13, [
                      _createVNode("span", _hoisted_14, [
                        _createVNode("img", {
                          class: "ui__defectList_title_defect_icon",
                          src: require('@/assets/image/warning.png')
                        }, null, 8, ["src"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.state.listDefectNumber) + "项异常 ", 1)
                      ])
                    ]))
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("img", {
                class: "ui__defectList_title_defect_icon",
                src: require('@/assets/image/success.png')
              }, null, 8, ["src"]),
              _createVNode("span", null, _toDisplayString(_ctx.state.listSumNumber) + "项无异常", 1)
            ])),
        _createVNode("div", _hoisted_16, [
          _createVNode("img", {
            src: require('@/assets/image/arrows.png'),
            class: {'ui__isShowAll':_ctx.state.isShowAll}
          }, null, 10, ["src"])
        ])
      ]),
      (_ctx.state.isShowAll)
        ? (_openBlock(), _createBlock("div", _hoisted_17))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode("div", _hoisted_18, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.defectList, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "ui__defectList_list_item",
          key: item.checkItemCode
        }, [
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, _toDisplayString(item.checkItemName), 1),
            _createVNode("div", _hoisted_21, [
              (item.itemDesc === '正常')
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    class: "ui__defectList_list_item_right_icon",
                    src: require('@/assets/image/success.png')
                  }, null, 8, ["src"]))
                : (item.itemDesc === '无此部件' || item.itemDesc === '受限不可检')
                  ? (_openBlock(), _createBlock("div", _hoisted_22, [
                      _createVNode("pre", _hoisted_23, _toDisplayString(item.itemDesc), 1),
                      _createVNode("img", {
                        class: "ui__defectList_list_item_right_icon",
                        src: require('@/assets/image/success.png')
                      }, null, 8, ["src"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_24, [
                      _createVNode("pre", _hoisted_25, _toDisplayString(_ctx.handleSignStatus(item.signRuleVOS)), 1),
                      _createVNode("img", {
                        class: "ui__defectList_list_item_right_icon",
                        src: require('@/assets/image/warning.png')
                      }, null, 8, ["src"])
                    ]))
            ])
          ]),
          (item.photoList && item.photoList.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                _createVNode("img", {
                  class: "ui__defectList_list_item_right_icona",
                  src: item.photoList[0].photoPath,
                  onClick: ($event: any) => (_ctx.showItemPhoto(item))
                }, null, 8, ["src", "onClick"]),
                _createVNode("div", null, [
                  _createVNode("img", {
                    src: require('@/assets/image/photoNew.png')
                  }, null, 8, ["src"]),
                  _createVNode("span", null, "共" + _toDisplayString(item.photoList.length) + "张", 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.state.isShowAll]
    ]),
    (_ctx.state.isShowModel)
      ? (_openBlock(), _createBlock(_component_bannerModel, {
          key: 0,
          photoList: _ctx.state.showPhotoList,
          onCloseModel: _ctx.closeModel
        }, null, 8, ["photoList", "onCloseModel"]))
      : _createCommentVNode("", true)
  ]))
})